import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/logo.svg';

const navigationItems = [
  { label: 'Home', path: '/', end: true },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Solutions', path: '/solutions' },
  { label: 'Products & Apps', path: '/products' },
  { label: 'Contact', path: '/contact' },
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, []);

  return (
    <nav className="navbar" aria-label="Primary navigation">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" aria-label="Bularis Tech home">
          <img src={logo} alt="" className="navbar-logo" />
          <span>Bularis Tech</span>
        </Link>
        <button type="button" className="navbar-toggle" aria-expanded={isMenuOpen} aria-controls="primary-navigation-links" aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'} onClick={() => setIsMenuOpen((current) => !current)}>
          <span></span><span></span><span></span>
        </button>
        <ul id="primary-navigation-links" className={`nav-links${isMenuOpen ? ' nav-links-open' : ''}`}>
          {navigationItems.map((item) => (
            <li key={item.path}>
              <NavLink to={item.path} end={item.end} className={({ isActive }) => isActive ? 'nav-link nav-link-active' : 'nav-link'} onClick={() => setIsMenuOpen(false)}>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
